// MODIFICADO POR: COLLA 30/10/2026 - cambio de clave obligatorio
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionsService } from './permissions.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private tokenSvc: TokenService,
    private pms: PermissionsService
  ) { }

  postLoginUser(user: any): Observable<any> {
    const datos = {
      ttUsuario: [{ usuario: user.usuario, password: user.password }],
    };
    return this.http.post('/cgi-bin/wspd_cgi.sh/WService=api/login.r', datos);
  }

  // MODIFICADO POR: COLLA 30/10/2026 - cambio de clave obligatorio
  postCambioClaveObligatorio(usuario: string, claveActual: string, claveNueva: string): Observable<any> {
    const datos = { ttCambioClave: [{ usuario, claveActual, claveNueva }] };
    return this.http.post('/cgi-bin/wspd_cgi.sh/WService=api/mutationCambioClaveObligatorio.r', datos);
  }

  loginUser(user: any) {
    return new Promise((resolve, reject) => {
      // EX2-340: login.r responde vacío cuando el usuario o la clave no coinciden;
      // solo es login válido si trae el token (si no, devuelve ttResultado[0] o false). Los errores HTTP se propagan.
      this.postLoginUser(user).subscribe({ next: (res) => {
        if (res?.acceso_token?.[0]?.token) {
          // EX2-289: el sessionStorage (dependientes, polizas, etc.) solo se
          // limpiaba en logoutUser(). Si se cambiaba de cuenta en la misma
          // pestaña sin pasar por "Cerrar sesion", quedaba pegado el cache
          // de dependientes del usuario anterior.
          this.tokenSvc.eliminarSessionStorage();
          // si el usuario esta activo seteo el token, lo dejo entrar y devuelvo true
          this.tokenSvc.setToken(res);
          this.router.navigate(['/extranet']);
          resolve(true);
        } else {
          // MODIFICADO POR: COLLA 30/10/2026 - devuelve ttResultado[0] (msg, debeCambiarClave) o false
          resolve(res?.ttResultado?.[0] ?? false);
        }
      }, error: (err) => reject(err) });
    });
  }

  logoutUser() {
    // elimino el token y redirecciono al login
    this.pms.limpioPermisos();
    this.tokenSvc.eliminarToken();
    // elimino el session storage
    this.tokenSvc.eliminarSessionStorage();
    this.router.navigate(['/auth']);
    window.location.reload();
  }

  isLogged(): boolean {
    const token = this.tokenSvc.getToken();
    if (token) {
      return true;
    } else {
      return false;
    }
  }
}
